import { render, staticRenderFns } from "./PriceGroup.vue?vue&type=template&id=b7c0694a&scoped=true&"
import script from "./PriceGroup.vue?vue&type=script&lang=js&"
export * from "./PriceGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c0694a",
  null
  
)

export default component.exports